export default {
    setUserAttestation(state, data) {
        state.userAttestations = data
    }
}
